import { connect } from 'react-redux'
import { LayoutDisplayComponent } from './LayoutDisplayComponent'
import type { RootState } from 'shared/store/reducers'

const mapStateToProps = (state: RootState) => {
    const { appInsertEnabled } = state.applicationState
    const { appBannerClosed } = state.userState
    return {
        showAppBanner: appInsertEnabled && !appBannerClosed
    }
}

const LayoutDisplay = connect(mapStateToProps)(LayoutDisplayComponent)

export { LayoutDisplay }
